import { useEffect, useRef, useState } from 'react'

import { registerGenderPrompt, type Gender } from '../gender'
import { t } from '../i18n'

/** Вопрос «М или Ж» перед первой записью в микст. Один на всё приложение:
 *  экраны вызывают ensureGender(), окно открывается здесь. */
export default function GenderPrompt({ onSaved }: { onSaved: () => void }) {
  const [open, setOpen] = useState(false)
  const resolver = useRef<((g: Gender | null) => void) | null>(null)

  useEffect(
    () =>
      registerGenderPrompt((resolve) => {
        resolver.current = resolve
        setOpen(true)
      }, onSaved),
    [onSaved],
  )

  function answer(value: Gender | null) {
    setOpen(false)
    resolver.current?.(value)
    resolver.current = null
  }

  if (!open) return null
  return (
    <div className="sheet-backdrop center" onClick={() => answer(null)}>
      <div className="popup" role="dialog" aria-modal="true" aria-label={t().genderAskTitle} onClick={(e) => e.stopPropagation()}>
        <div className="title">{t().genderAskTitle}</div>
        <p className="muted" style={{ margin: '6px 0 14px' }}>
          {t().genderAskHint}
        </p>
        <div className="row" style={{ gap: 8 }}>
          <button style={{ flex: 1 }} onClick={() => answer('m')}>
            {t().genderMan}
          </button>
          <button style={{ flex: 1 }} onClick={() => answer('f')}>
            {t().genderWoman}
          </button>
        </div>
        <button className="link" style={{ width: '100%', marginTop: 8 }} onClick={() => answer(null)}>
          {t().inviteLater}
        </button>
      </div>
    </div>
  )
}
